import React, { useCallback } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useIdentity } from '@internal/shared';
import { ChatBubble, NexusProvider } from '@nexus-os/overlay-chat';
import '@nexus-os/overlay-chat/styles.css';
import '../../praxo-chat.generated.css';

const DEFAULT_CHAT_PATH = '/chat';

function joinUrlPath(...segments: string[]): string {
  return segments
    .map((segment, index) => {
      if (index === 0) {
        return segment.replace(/\/+$/, '');
      }

      return segment.replace(/^\/+/, '').replace(/\/+$/, '');
    })
    .filter(Boolean)
    .join('/');
}

export function PraxoChatWidget() {
  const configApi = useApi(configApiRef);
  const { getIdToken, profile, idToken } = useIdentity();

  const enabled =
    configApi.getOptionalBoolean('featureFlags.praxoChat') ?? false;
  const baseUrl = configApi.getOptionalString('praxoChat.baseUrl') ?? '';
  const chatPath =
    configApi.getOptionalString('praxoChat.chatPath') ?? DEFAULT_CHAT_PATH;

  const endpoint = baseUrl ? joinUrlPath(baseUrl, chatPath) : null;

  const getAuthToken = useCallback(async () => {
    const token = await getIdToken();
    return token || null;
  }, [getIdToken]);

  if (!enabled || !idToken || !endpoint || !profile?.userId) {
    return null;
  }

  return (
    <div className="praxo-chat-host">
      <NexusProvider getAuthToken={getAuthToken}>
        <ChatBubble
          endpoint={endpoint}
          appContext="dx-portal"
          userId={profile.userId}
          position="bottom-right"
        />
      </NexusProvider>
    </div>
  );
}
